export const MOT_CHECK_STATUS_CODES = {
  INVALID_VRM: 424,
  NOT_FOUND: 404,
  STATUS_PENDING: 202,
  STATUS_SUCCESS: 200,
  TECHNICAL_DIFFICULTIES: 500,
} as const;

export const MOT_CHECKER_CONTRACT_TEST_ENDPOINT_PATH = 'http://127.0.0.1:3000/mot/checker';
export const MOT_NOTIFICATIONS_CONTRACT_TEST_ENDPOINT_PATH = 'http://127.0.0.1:3000/mot/notifications';
